import React from 'react';
import Wrapper from './StyledPage';

export const Settings = () => {
  return <Wrapper>Settings</Wrapper>;
};
